import { SUCCESS_STATUS } from "../Constants/http";
export var isSuccess = function isSuccess(status) {
  return SUCCESS_STATUS.OK === status;
};